var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSadSmileGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2471_8344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "lightgray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93551 11.9997C7.40104 11.9997 6.96777 11.5664 6.96777 11.032V10.2578C6.96777 9.7233 7.40104 9.29004 7.93551 9.29004C8.46998 9.29004 8.90324 9.7233 8.90324 10.2578V11.032C8.90324 11.5664 8.46998 11.9997 7.93551 11.9997Z",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93549 9.29004C7.86921 9.29004 7.80452 9.29684 7.74194 9.30954V10.6449C7.74194 10.9655 8.00191 11.2255 8.32258 11.2255C8.64326 11.2255 8.90322 10.9655 8.90322 10.6449V10.2578C8.90322 9.72326 8.47001 9.29004 7.93549 9.29004Z",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0645 11.9997C15.5301 11.9997 15.0968 11.5664 15.0968 11.032V10.2578C15.0968 9.7233 15.5301 9.29004 16.0645 9.29004C16.599 9.29004 17.0323 9.7233 17.0323 10.2578V11.032C17.0323 11.5664 16.599 11.9997 16.0645 11.9997Z",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0645 9.29004C15.9982 9.29004 15.9335 9.29684 15.871 9.30954V10.6449C15.871 10.9655 16.1309 11.2255 16.4516 11.2255C16.7723 11.2255 17.0323 10.9655 17.0323 10.6449V10.2578C17.0323 9.72326 16.599 9.29004 16.0645 9.29004Z",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12753 17.9034C8.01034 17.9034 7.89278 17.861 7.79978 17.7756C7.60319 17.5945 7.59034 17.2885 7.77142 17.0917C8.75355 16.0244 10.334 15.3872 11.9985 15.3872C13.6636 15.3872 15.2438 16.0246 16.2255 17.0919C16.4066 17.2885 16.3937 17.5947 16.1971 17.7756C16.001 17.9567 15.6944 17.9444 15.5133 17.747C14.7115 16.8753 13.3975 16.3549 11.9984 16.3549C10.5997 16.3549 9.28572 16.8753 8.48355 17.7472C8.38839 17.8509 8.25794 17.9034 8.12753 17.9034Z",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7419 22.258C7.1145 22.258 1.74192 16.8855 1.74192 10.258C1.74192 7.38802 2.75072 4.75439 4.43142 2.68945C1.72795 4.88977 0 8.24255 0 12C0 18.6274 5.37258 24 12 24C15.7575 24 19.1102 22.272 21.3106 19.5685C19.2456 21.2492 16.612 22.258 13.7419 22.258Z",
    fill: "lightgray"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2471_8344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadSmileGray);
export default __webpack_public_path__ + "static/media/sad-smile-gray.62b5b0cba95798243079bb331d83b8fb.svg";
export { ForwardRef as ReactComponent };